export type StatusPago = 'AL_DIA' | 'PENDIENTE' | 'ATRASADO' | 'SALDO_FAVOR';

export interface IPagoInmuebleListItem {
    casa: number;
    num_Casa: string;
    nombre: string;
    saldo: number;
    status: StatusPago;
}

export interface IDetalleCasaPago {
    casa: number;
    num_Casa: string;
    nombre: string;
    nit: string;
    email: string;
    telefono: string;
    nombre_Contacto: string;
    email_Contacto: string;
    saldo: number;
}

export interface ITrxCasa {
    linea: number;
    fecha: string;
    servicio: number;
    nom_Servicio: string;
    cargo: number;
    abono: number;
    saldo: number;
    nota: string;
    id_Abono?: number;
    id_Cargo?: number;
}

export interface IServicioCatalogo {
    servicio: number;
    nombre: string;
    valor: number;
}

export interface IRegistrarPagoRequest {
    empresa?: number;
    agencia?: number;
    casa: number;
    servicio: number;
    fecha: string; // yyyy-MM-dd
    fecha_Operacion: string; // yyyy-MM-dd
    medio_Pago: number;
    boleta: string;
    emisor: string;
    saldo_Anterior: number;
    cuota: number;
    cuota_Extra: number;
    agua: number;
    mora: number;
    multa: number;
    otros: number;
    amenidades: number;
    valor_Total: number;
    nota: string;
    usuario?: string;
    archivo: string;
    uuid_Dte: string;
    banco: string;
    cuenta_Banco: string;
    tipo_Documento: string;
    estado: number; // 1 = ingresando, 2 = aprobada
}

export interface IRegistrarPagoResponse {
    success: boolean;
    message: string;
    id_Abono: number;
}

export interface ICambiarEstadoPagoRequest {
    empresa?: number;
    agencia: number;
    casa: number;
    id_Abono: number;
    usuario?: string;
    motivo_Anulacion?: string;
}

export interface ICargaMasivaResultado {
    casa: number;
    success: boolean;
    message: string;
    id_Abono: number;
}

export const MEDIOS_PAGO = [
    { value: 1, label: 'Deposito' },
    { value: 2, label: 'Ch/Transf/NC' },
    { value: 3, label: 'Ambos' },
    { value: 4, label: 'Banca en Linea' },
    { value: 5, label: 'Otro' },
];

export const STATUS_LABELS: Record<StatusPago, string> = {
    AL_DIA: 'Al día',
    PENDIENTE: 'Pendiente',
    ATRASADO: 'Atrasado',
    SALDO_FAVOR: 'Saldo a favor',
};
